import { Action } from '@ngrx/store';
import { CompanyVoteResultSearchFilter } from '../../models/companyVoteResultSearchFilter';

export enum ECompanyVoteResultListActions {
  SetSearchFilter = '[Company Vote Result List] SET SEARCH FILTER',
  SetPagination = '[Company Vote Result List] SET PAGINATION',
  SetSort = '[Company Vote Result List] SET SORT',
  ClearFilters = '[Company Vote Result List] CLEAR FILTERS'
}

export class SetSearchFilter implements Action {
  public readonly type = ECompanyVoteResultListActions.SetSearchFilter;
  constructor(public payload: CompanyVoteResultSearchFilter) {}
}

export class SetPagination implements Action {
  public readonly type = ECompanyVoteResultListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetSort implements Action {
  public readonly type = ECompanyVoteResultListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearFilters implements Action {
  public readonly type = ECompanyVoteResultListActions.ClearFilters;
}

export type CompanyVoteResultListActions =
  | SetSearchFilter
  | SetPagination
  | SetSort
  | ClearFilters;
